import React, { useEffect, useRef, useState } from "react";
import img1 from "./component/images/26.jpg"; 
import img2 from "./component/images/27.jpg"; 
import img3 from "./component/images/29.jpg"; 
import img4 from "./component/images/28.jpg"; 
import img5 from "./component/images/30.jpg"; 
import "./component/css/achivement.css";
import Top_heading from "./component/Top_heading";


export default function ExactGalleryCarousel() {
  // five items using the same local image
  const [items, setItems] = useState([
    { id: 0, pos: 0, url: img1 },
    { id: 1, pos: 1, url: img2 },
    { id: 2, pos: 2, url: img3 },
    { id: 3, pos: 3, url: img4 },
    { id: 4, pos: 4, url: img5 },
  ]);

  // container width measured to compute translate exactly like `calc(var(--width) * 0.2 * pos)`
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(900); // fallback

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // measure initial width (match CSS: min(1000px, 90vw))
    const measure = () => {
      const w = el.getBoundingClientRect().width;
      setContainerWidth(w);
    };
    measure();

    // update on resize
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const scaleMap = { 0: 1, 1: 1.4, 2: 1.8, 3: 1.4, 4: 1 };
  const zMap = { 0: 1, 1: 5, 2: 10, 3: 5, 4: 1 };

  function shuffle(clickedItem) {
    const heroPos = Math.floor(items.length / 2); // 2
    const heroIndex = items.findIndex((it) => it.pos === heroPos);
    const targetIndex = items.findIndex((it) => it.id === clickedItem.id);
    if (heroIndex === -1 || targetIndex === -1) return;

    setItems((prev) => {
      const next = prev.map((it) => ({ ...it })); // clone
      const tmp = next[targetIndex].pos;
      next[targetIndex].pos = next[heroIndex].pos;
      next[heroIndex].pos = tmp;
      return next;
    });
  }

  return (
    <>
    <div className="egc-wrapper" ref={containerRef} aria-hidden="false">
      {/* UL structure matches your original */}
      <ul className="egc-gallery">
        {items.map((item) => {
          const translatePx = containerWidth * 0.2 * item.pos;
          const scale = scaleMap[item.pos] ?? 1;
          const z = zMap[item.pos] ?? 1;

          const style = {
            transform: `translateX(${translatePx}px) scale(${scale})`,
            zIndex: z,
            backgroundImage: `url(${item.url})`,
          };

          return (
            <li
              key={item.id}
              data-pos={item.pos}
              className="egc-item"
              style={style}
              onClick={() => shuffle(item)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") shuffle(item);
              }}
              aria-label={`gallery-item-${item.id}`}
            />
          );
        })}
      </ul>
      
    </div>
    <div className="client-main1">
    <div className="client-para">
        <p>Dubai, UAE - We are proud to announce that our company has been honored with the prestigious 'New Gen Icon Award' in Dubai, recognizing our commitment to innovation, leadership, and excellence. Winning this award in Dubai - a global hub for ambition and progress highlights our role as part of the next generation shaping the future of our industry.


Adding to the pride of this achievement, our recognition was featured across multiple leading UAE news platforms, including <a href="https://www.khaleejtimes.com/kt-network/tally-msme-honours-2025-recognises-entrepreneurial-excellence-in-the-uae" target="_blank">Khaleej Times</a>, <a href="https://www.zawya.com/en/press-release/events-and-conferences/tally-msme-honours-2025-recognises-entrepreneurial-excellence-in-the-uae-ud2ftsgf" target="_blank">Zawya</a>, <a href="https://integratormedia.com/2025/09/01/tally-msme-honours-2025-celebrates-uae-excellence/" target="_blank">Integrator Media</a>, and <a href="https://www.catch.ae/awards/uaes-trailblazing-smes-honoured-at-tally-msme-honours-2025/">Catch</a>. Being showcased by such respected publications amplifies our journey and strengthens our presence within the region’s rapidly evolving business landscape.
This award is a testament to the dedication of our team, the trust of our partners, and the support of our customers. It fuels our passion to keep innovating, inspiring, and leading with purpose as we move forward toward even greater milestones and a brighter future.</p>
      </div>
      </div>
      </>
  );
}
